module.exports = __webpack_public_path__ + "img/青丘男.ea7ed09e.png";